export const getUrlFromParameterManager = async (
    parametrizedUrl: string
): Promise<string | undefined> => {
    if (!parametrizedUrl) return undefined;
    const response = await fetch(parametrizedUrl);
    if (!response.ok) return undefined;
    return response.text();
};
